module.exports = __webpack_public_path__ + "img/miccai2025-first.11e9e8b1.png";